import { formatProduct } from "./utilfunction";
import { formatLastActivityTime } from "./utilfunction";
export const getOrderDetailFields = (order, formatTime, type = 'PENDING') => {
  const baseFields = [
    { label: 'Order ID', value: order.oms_order_id },
    { label: 'Order Type', value: order.order_type },
    { label: 'Product', value: formatProduct(order.product) },
    { label: 'Exchange Order ID', value: order.exchange_order_id },
  ];

  switch (type) {
    case 'PENDING':
      return [
        ...baseFields,
        {
          label: 'Price',
          value: `₹ ${order.price.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
        },
        
        { label: 'Tr. Price', value: order.trigger_price || 'N/A' },
        { label: 'Avg. Price', value: order.average_price || 'N/A' },
        { label: 'Disc. Qty', value: order.disclosed_quantity },
        { label: 'Client ID', value: order.client_id },
        {
          label: 'Order Update Time',
          value: formatLastActivityTime(order.last_activity_reference),
        },
        { label: 'Order Entry Time', value: formatTime(order.order_entry_time) },
        { label: 'Status', value: order.order_status },
      ];

    case 'COMPLETED':
      return [
        ...baseFields,
        {
          label: 'Price',
          value: `₹ ${order.price.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
        },
        { label: 'Tr. Price', value: order.trigger_price || 'N/A' },
        { label: 'Avg. Price', value: order.average_price || 'N/A' },
        { label: 'Disc. Qty', value: order.disclosed_quantity },
        { label: 'Client ID', value: order.client_id },
        {
          label: 'Order Update Time',
          value: formatLastActivityTime(order.last_activity_reference),
        },
        { label: 'Order Entry Time', value: formatTime(order.order_entry_time) },
        { label: 'Status', value: order.order_status },
      ];

    case 'TRADE':
      return [
        ...baseFields,
        {
          label: 'Price',
          value: `₹ ${order.trade_price.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
        },
        { label: 'Order Entry Time', value: formatTime(order.order_entry_time) },
      ];

    default:
      return baseFields;
  }
}; 